import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-modal-action-header__swipe-indicator" }, null, -1)
const _hoisted_2 = { class: "c-modal-action-header__inline-wrap" }
const _hoisted_3 = { class: "c-modal-action-header__start" }
const _hoisted_4 = { class: "c-modal-action-header__end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_c_transparent_button = _resolveComponent("c-transparent-button")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), { class: "c-modal-action-header" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "start")
        ]),
        _createElementVNode("div", {
          class: "c-modal-action-header__title",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-title')))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "end", _normalizeProps(_guardReactiveProps({ emitClose: _ctx.emitClose })), () => [
            _createVNode(_component_c_transparent_button, {
              class: "c-modal-action-header__close-btn",
              onClick: _ctx.emitClose
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { name: "close-outline" })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}